module.exports = __webpack_public_path__ + "img/orange_135.d3ef0a06.png";